import type { FC } from 'react';
import TMSGetQuoteScreen from '../../screens/Shipment/TMSGetQuoteScreen';

const GetQuotePage: FC = () => {
  return (
    <div className="h-100 pb-15">
      <TMSGetQuoteScreen />
    </div>
  );
};

export default GetQuotePage;
